<script setup lang="ts">
import type { WithClassAsProps } from './interface';
import { ArrowRight } from 'lucide-vue-next';
import { Button } from '@/components/ui/button';
import { useCarousel } from './useCarousel';

const props = defineProps<WithClassAsProps>();

const { orientation, canScrollNext, scrollNext } = useCarousel();
</script>

<template>
  <Button
    :disabled="!canScrollNext"
    :class="
      cn(
        'absolute h-8 w-8 touch-manipulation p-0 focus-visible:ring-brand-primary-700',
        orientation === 'horizontal'
          ? '-right-12 top-1/2 -translate-y-1/2'
          : '-bottom-12 left-1/2 -translate-x-1/2 rotate-90',
        props.class,
      )
    "
    variant="secondary"
    color="gray"
    shape="full"
    @click="scrollNext"
  >
    <slot>
      <ArrowRight class="h-4 w-4 text-current" />
      <span class="sr-only">Next Slide</span>
    </slot>
  </Button>
</template>
